import "moment/locale/ko";
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import styled from "styled-components";
import RecoilReceiptModal from "../../components/modal/RecoilReceiptModal";
import StoreController, {
  MapStoreType,
} from "../../controller/StoreController";
import { PositionContextType } from "../../controller/UserController";

const FavoriteStore = () => {
  const { position } = useOutletContext<PositionContextType>();

  const navigate = useNavigate();

  const [storeList, setStoreList] = useState<MapStoreType[]>([]);

  // API 호출
  const getFavorite = async () => {
    try {
      const oParams = {
        user_lat: position.lat,
        user_lng: position.lng,
      };
      const oRes = await StoreController.getFavoritesStore(oParams);

      if (oRes && oRes.data && oRes.data.content) {
        console.log("getFavoritesStore", oRes.data);
        setStoreList([...oRes.data.content.data]);
      }
    } catch (err) {
      console.log("err---->", err);
    }
  };
  const setFavorite = async (item: MapStoreType) => {
    try {
      const oParams = {
        store_id: item.store_id,
        favorites_flag: item.favorites_flag === 1 ? 0 : 1,
      };
      const oRes = await StoreController.setFavoritesStore(oParams);

      if (oRes && oRes.data && oRes.data.success) {
        console.log("setFavoritesStore", oRes.data);
        storeList.map((store) => {
          if (store.store_id === item.store_id)
            store.favorites_flag = store.favorites_flag === 1 ? 0 : 1;
        });
        setStoreList([...storeList]);
      }
    } catch (err) {
      console.log("err---->", err);
    }
  };

  useEffect(() => {
    getFavorite();
  }, []);

  const RenderFavoriteItem = useMemo(() => {
    return (
      <div className="listWrap">
        {storeList.map((item, index) => (
          <div className="listItem" key={index}>
            <img
              onClick={() =>
                navigate("/order/main", { state: { store_id: item.store_id } })
              }
              src={
                item.url_path === null || item.url_path === ""
                  ? `${process.env.PUBLIC_URL}/svg/ic_stamp_none.svg`
                  : item.url_path
              }
              alt="storeImage"
            />
            <div className="content">
              <div className="title">
                <h1 className="limitText">{item.store_name}</h1>
                <button onClick={() => setFavorite(item)}>
                  {item.favorites_flag === 1 ? (
                    <img
                      src={`${process.env.PUBLIC_URL}/svg/ic_heartColor.svg`}
                      alt="heart"
                    />
                  ) : (
                    <img
                      src={`${process.env.PUBLIC_URL}/svg/ic_heart.svg`}
                      alt="heart"
                    />
                  )}
                </button>
              </div>
              <h2>{item.distance.toFixed(1)}km</h2>
            </div>
          </div>
        ))}
      </div>
    );
  }, [storeList]);

  return (
    <>
      <Style>
        <div className="wrapper">
          <h1>즐겨찾는 매장</h1>
          {RenderFavoriteItem}
        </div>
      </Style>
      <RecoilReceiptModal />
    </>
  );
};

export default FavoriteStore;

const Style = styled.div`
  .wrapper {
    width: 100vw;
    height: 100vh;
    padding: 20px 60px;
    overflow: hidden;
  }
  h1 {
    margin-bottom: 26px;
    font-size: 40px;
    font-weight: 600;
    color: #fff;
    text-align: center;
  }

  /* orderHistoryWrap */
  .listWrap {
    height: calc(100% - 86px);
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    overflow-y: auto;
  }
  .listItem {
    display: flex;
    flex-direction: column;
    width: calc(25% - 16px);
    height: 420px;
    border-radius: 10px;
    img {
      width: 100%;
      height: 70%;
      border-radius: 10px 10px 0 0;
    }
    .content {
      max-width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 30%;
      background: #242424;
      padding: 16px 20px;
      border-radius: 0 0 10px 10px;
      .title {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      h1 {
        max-width: 300px;
        font-size: 36px;
        line-height: 50px;
        font-weight: 600;
        margin: 0;
      }
      h2 {
        font-size: 28px;
        line-height: 40px;
        color: #a7a7a7;
      }
      button {
        background: none;
        padding: 0;
      }
      img {
        width: 40px;
        height: 40px;
      }
    }
  }

  @media (max-width: 1400px) {
    .wrapper {
      padding: 4%;
    }
    h1 {
      margin-bottom: 3rem;
      font-size: 3rem;
    }

    .listWrap {
      flex: 1;
      height: auto;
      gap: 16px;
    }
    .listItem {
      width: calc((100% - 32px) / 3);
      height: auto;

      img {
        height: 260px;
      }
      .content {
        height: auto;
        padding: 14px 20px;
        .title {
          gap: 10px;
        }
        h1 {
          max-width: 90%;
          font-size: 2rem;
          line-height: 3rem;
          font-weight: 600;
          margin: 0;
        }
        h2 {
          font-size: 1.6rem;
          line-height: 2.5rem;
          color: #a7a7a7;
        }
        button {
          background: none;
          padding: 0;
        }
        img {
          width: 3rem;
          height: 3rem;
        }
      }
    }
  }
`;
